var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.12471 22C1.56114 22 1.02105 21.7825 0.622542 21.3957C0.224038 21.0089 0 20.4858 0 19.9388V10.3129C0 9.76589 0.224038 9.24052 0.622542 8.85371C1.02105 8.4669 1.56114 8.24944 2.12471 8.24944H2.83372V5.50112C2.83372 4.04237 3.43 2.64289 4.49268 1.61139C5.55535 0.579902 6.99715 0 8.5 0C10.0029 0 11.4435 0.579902 12.5062 1.61139C13.5688 2.64289 14.1663 4.04237 14.1663 5.50112V8.24944H14.8741C15.4377 8.24944 15.979 8.4669 16.3775 8.85371C16.776 9.24052 17 9.76589 17 10.3129V19.9388C17 20.4858 16.776 21.0089 16.3775 21.3957C15.979 21.7825 15.4377 22 14.8741 22H2.12471ZM1.63462 20.3824H15.3654V9.70588H1.63462V20.3824ZM12.6431 8.13043V5.50112C12.6431 4.5894 12.1065 3.09517 11.4423 2.45048C10.7781 1.8058 9.43928 1.47989 8.5 1.47989C7.56072 1.47989 6.22187 1.74662 5.55769 2.3913C4.89352 3.03599 4.25 4.26475 4.25 5.17647V8.13043H12.6431Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.e9aa8d18.svg";
export { ForwardRef as ReactComponent };